import { render, staticRenderFns } from "./MarketRates.vue?vue&type=template&id=7bfda267&scoped=true&"
import script from "./MarketRates.vue?vue&type=script&lang=js&"
export * from "./MarketRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfda267",
  null
  
)

export default component.exports